import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  centerpage: {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#2b2b2b',
    color: 'white',
  },
  icon: {
    color: 'white',
    fontSize: '10rem',
  },
});

function Error() {
  const classes = useStyles();

  return (
    <div className={classes.centerpage}>
      <i className={classNames('material-icons', classes.icon)}>cloud_off</i>
      <h2>Il y a un problème avec votre lien.</h2>
    </div>
  );
}

export default Error;
